export default __webpack_public_path__ + "static/media/dc-flash.b3922f25.jpg";